module.exports = __webpack_public_path__ + "img/default-image.f065b10c.png";